import useEntityTable from "hooks/useEntityTable";
import {
  listUsers,
  createUser,
  updateUser,
  deleteUser,
  activateUser,
  deactivateUser,
} from "api/endpoints/users";

// Stable api reference for useEntityTable.
const usersApi = {
  list: listUsers,
  create: createUser,
  update: updateUser,
  remove: deleteUser,
  activate: activateUser,
  deactivate: deactivateUser,
};

// Data + actions for the Users table.
export default function useUsersTable() {
  return useEntityTable({ api: usersApi, entityName: "User" });
}
